import { Outlet } from "react-router-dom";
import { HeaderLogo } from "@/shared/components/custom/layout/header/HeaderLogo";

export function AuthLayout() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-background overflow-hidden px-4 py-12">
      {/* Logo centrado en la parte superior */}
      <div className="mb-8">
        <HeaderLogo />
      </div>

      {/* Contenedor del formulario */}
      <div className="relative z-10 w-full max-w-100 flex flex-col items-center">
        <Outlet />
      </div>

      {/* Franja degradada inferior */}
      <div
        className="absolute top-0 left-0 right-0 h-full w-full bg-[radial-gradient(140%_125%_at_50%_-10%,transparent_80%,var(--secondary)_100%)]"
        aria-hidden="true"
      />
    </div>
  );
}
